import { render, staticRenderFns } from "./CatalogEdit.vue?vue&type=template&id=e677eed8&"
import script from "./CatalogEdit.vue?vue&type=script&lang=ts&"
export * from "./CatalogEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports